var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExchangeMob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4585",
    "data-name": "Group 4585",
    transform: "translate(-261 -205)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(261 205)",
    fill: "rgba(59,176,255,0.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4467",
    "data-name": "Group 4467",
    transform: "translate(-965 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "exchange-r",
    transform: "translate(1235.793 216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    d: "M8.411,3.5,5.223,6.688H21.75v1.5H5.236l3.188,3.187L7.363,12.436,3.419,8.492,3.413,8.5,2.352,7.438l5-5Z",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    "data-name": "Path 3209",
    d: "M19.177,17.313H2.663v-1.5H19.19L16,12.625l1.061-1.061,5,5L21,17.623l-.006-.006L17.05,21.561,15.99,20.5Z",
    fill: "#3bb0ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2343",
    "data-name": "Rectangle 2343",
    width: 24,
    height: 24,
    transform: "translate(1236 216)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchangeMob);
export default __webpack_public_path__ + "static/media/icon-exchange_mob.27facb0c78c50c98fa3f8e681c21e6fe.svg";
export { ForwardRef as ReactComponent };